import React, { useState } from 'react';
import { AiPlatformSection } from '../components/AiPlatformSection';
import { DataFoundationSection } from '../components/DataFoundationSection';
import { DemandCalloutSection } from '../components/DemandCalloutSection';
import EventList from '../components/EventList';
import { GetStartedDialog } from '../components/GetStartedDialog';
import { HeroSection } from '../components/HeroSection';
import { LogosSection } from '../components/LogosSection';
import { CommerceLoopSection } from '../components/CommerceLoopSection';
import { SEO } from '../components/SEO';
import { TestimonialSection } from '../components/TestimonialSection';
import MainLayout from '../layouts/main';

export default () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <MainLayout>
      <SEO />
      <HeroSection onGetStarted={() => setDialogOpen(true)} />
      <GetStartedDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
      <LogosSection />
      <TestimonialSection />
      <CommerceLoopSection />
      <DataFoundationSection />
      <AiPlatformSection />
      <DemandCalloutSection />
      <EventList />
    </MainLayout>
  );
};
